var e = (i, s, o) => new Promise((p, a) => {
  var l = (t) => {
    try {
      r(o.next(t));
    } catch (n) {
      a(n);
    }
  }, m = (t) => {
    try {
      r(o.throw(t));
    } catch (n) {
      a(n);
    }
  }, r = (t) => t.done ? p(t.value) : Promise.resolve(t.value).then(l, m);
  r((o = o.apply(i, s)).next());
});
import { selfAxios as c } from "@oppein/op-utils";
function y(i) {
  return e(this, null, function* () {
    const { data: s } = yield c.post(
      "/bsplatform/external/commodity/listOptionsByAttribute",
      i
    );
    return s;
  });
}
export {
  y as listOptionsByAttribute
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/bsplatform/external/commodity/listOptionsByAttribute/post.js
// module id = 1799
// module chunks = 67